import type { User } from '../firebase/firebase';
import {
	defaultCloudFunctionServices,
	makeCloudFunctionRequestReturnSuccessStatus,
} from './BaseCloudFunctionRequests';
import { HTTPSCloudFunctionURLs } from './HTTPSCloudFunctionURLs';

export const deletePayrollIntegration = (
	abortSignal: AbortSignal,
	user: User,
): Promise<boolean | undefined> => {
	return makeCloudFunctionRequestReturnSuccessStatus({
		abortSignal,
		user,
		url: HTTPSCloudFunctionURLs.PayrollDelete,
		method: 'DELETE',
		services: defaultCloudFunctionServices,
	});
};
